import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiResponse } from '@app/_models';
import { UserService, AlertService } from '@app/_services';

@Injectable({
    providedIn: 'root'
})

@Injectable()
export class UserResolver  {

    constructor(
        private router: Router,
        private userService: UserService,
        private alertService: AlertService) { }

    resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): Observable<ApiResponse>
    {
        return this.userService.findById(+activatedRouteSnapshot.paramMap.get('userId'));
    }
}
